<template>
  <div class="vip-page">
    <div class="toolbar">
      <el-button type="primary" @click="openDialog">新增等级</el-button>
    </div>
    <el-table :data="list" stripe style="width:100%">
      <el-table-column prop="name" label="等级名称" />
      <el-table-column prop="description" label="等级概述" />
      <el-table-column label="操作" width="150">
        <template #default="{row}">
          <el-button size="small" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" :current-page="pagination.page" :page-size="pagination.pageSize" :total="pagination.total" layout="prev, pager, next" @current-change="pageChange" />

    <el-dialog v-model="dialogVisible" title="会员等级" width="400px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="名称"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="概述"><el-input v-model="form.description" /></el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import request from '../../utils/request'

const list = ref([])
const pagination = ref({page:1,pageSize:30,total:0})
const dialogVisible = ref(false)
const loading = ref(false)
const form = ref({id:null,name:'',description:''})

const loadList = async()=>{
  const params={page:pagination.value.page,pageSize:pagination.value.pageSize}
  try{ const data=await request.get('/v1/vip-level/list',{params});
    list.value=data.list; pagination.value.total=data.pagination.total }
  catch(e){ElMessage.error(e.toString())}
}

const pageChange=(p)=>{pagination.value.page=p;loadList()}

const openDialog=()=>{form.value={id:null,name:'',description:''};dialogVisible.value=true}

const edit=(row)=>{form.value={id:row.id,name:row.name,description:row.description};dialogVisible.value=true}

const submit=async()=>{
  loading.value=true
  try{
    if(form.value.id) await request.post('/v1/vip-level/update',form.value)
    else await request.post('/v1/vip-level/create',form.value)
    ElMessage.success('操作成功');dialogVisible.value=false;loadList()
  }catch(e){ElMessage.error(e.toString())}
  finally{loading.value=false}
}

const remove=async(row)=>{
  try{await request.post('/v1/vip-level/delete',{id:row.id});ElMessage.success('删除成功');loadList()}catch(e){ElMessage.error(e.toString())}
}

loadList()
</script>

<style scoped>
.vip-page .toolbar{margin-bottom:15px}
.pager{margin-top:15px;text-align:right}
</style>
